export const USERS = {
    login: "login",
    createEmpleado: "createEmpleado",
    getEmpleados: "getEmpleados",
    updateEmpleado: "updateEmpleado",
    detalleEmpleado: "detalleEmpleado",

    presignContrato: (numeroEmpleado) => `updateEmpleado/${numeroEmpleado}/presignContrato`,
    attachContrato: (numeroEmpleado) => `updateEmpleado/${numeroEmpleado}/attachContrato`,
};

export const CHECADOR = {
    getChecador: "getChecador"
}
